import React from 'react';

import FaUser from 'react-icons/lib/fa/user';

import {
    WDSButton,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './TravelerInfo.scss';

import type {
    TravelerInfoProps,
} from '../types';

const TravelerInfo = ({
    seats,
    t,
    togglePassengerModal,
}: TravelerInfoProps) => {
    return (
        <div className={styles.container}>
            <div className={styles.text}>
                <FaUser className={styles.icon} />
                {t<string>('multiple-passenger-classes', { context: 'paxtypes', count: seats })}
            </div>

            <WDSButton
                className={styles.button}
                onClick={togglePassengerModal}
                type="button"
                variant="unstyled"
            >
                <span className={styles.title}>{t<string>('change-trip')}</span>
            </WDSButton>
        </div>
    );
};

export { TravelerInfo };
export default localize(TravelerInfo, ['t'], 'baseApp');
